// extracted by mini-css-extract-plugin
export default {"change-plan-page":"style_change-plan-page__FkIf4","change-plan-title":"style_change-plan-title__+7IwO","change-plan-content":"style_change-plan-content__xU73V"};